import { EMPTY_GUID } from "./dataset-profile-dto";

export interface CustomFieldSelectionDto {
  customFieldId: number;
  includeField: boolean;
}

export interface CustomFieldAssignmentsProfileDto {
  fields: CustomFieldSelectionDto[];
}

export class DocProfileDto {
  id = EMPTY_GUID;
  version = 0;
  profileName = '';
  owningOrganizationId = 0;
  isDefaultProfile = false;
  customFieldsForSection1: CustomFieldAssignmentsProfileDto | null = null;
  customFieldsForSection8: CustomFieldAssignmentsProfileDto | null = null;
  excludedEvidenceTypes: string[] = [];
}
